// frontend/src/service/user-service.ts
import axios from "axios";
import axiosInstance from "../configuration/api";

export const handleUserSign = async (emailId: string, password: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;

  return (
    await axios.post(`${baseUrl}/api/v1/user`, {
      emailId,
      password,
    })
  ).data;
};

export const fetchAllUsers = async () => {
  const baseUrl = process.env.REACT_APP_API_HOST;

  return (await axiosInstance.get(`${baseUrl}/api/v1/user/all`)).data;
};
